'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _PlanScorecardToActionCenter = require('./PlanScorecardToActionCenter.css');

var _PlanScorecardToActionCenter2 = _interopRequireDefault(_PlanScorecardToActionCenter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardToActionCenter = (_dec = (0, _reactCssModules2.default)(_PlanScorecardToActionCenter2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(PlanScorecardToActionCenter, _Component);

  function PlanScorecardToActionCenter() {
    (0, _classCallCheck3.default)(this, PlanScorecardToActionCenter);
    return (0, _possibleConstructorReturn3.default)(this, (PlanScorecardToActionCenter.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardToActionCenter)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanScorecardToActionCenter, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _.ContainerDivs,
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'take-action-share' },
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-label' },
            _react2.default.createElement(
              'h2',
              null,
              'Want more sustainable options in your 401(k) plan?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Learn how to work with your employer to ensure your retirement plan is sustainably invested.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-icons' },
            _react2.default.createElement(
              'div',
              { styleName: 'scorecard-methodology-link' },
              _react2.default.createElement(
                _.Link,
                {
                  to: _config2.default.routes.eduCenter,
                  title: 'Action center',
                  transparentbutton: true
                },
                'Action center',
                _react2.default.createElement(_.LinkIcon, null)
              )
            )
          )
        )
      );
    }
  }]);
  return PlanScorecardToActionCenter;
}(_react.Component)) || _class);
exports.default = PlanScorecardToActionCenter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardToActionCenter/PlanScorecardToActionCenter.js
// module id = 1430
// module chunks = 0